import { ONE_MONTH_IN_SECONDS } from '@/src/general/constants/time'

import { decodeToken } from './decodeToken'

export function isTokenExpiringSoon(token: string) {
  const tokenPayload = decodeToken(token)
  if (!tokenPayload?.exp || tokenPayload.impersonation) return false
  const currentTime = Date.now() / 1000
  return tokenPayload.exp - currentTime < ONE_MONTH_IN_SECONDS
}
